(() => {
  // Prevent this bridge from wrapping fetch more than once.
  if (window.__swishlistCartBridgeInstalled) return;
  window.__swishlistCartBridgeInstalled = true;

  const originalFetch = window.fetch.bind(window);
  let refreshInProgress = false;
  let refreshQueued = false;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    let url;

    try {
      const request = args[0];
      url = new URL(
        request instanceof Request ? request.url : String(request),
        window.location.origin
      );
    } catch {
      return response;
    }

    // Only process successful Shopify cart-add requests.
    if (
      !/\/cart\/add(?:\.js)?\/?$/.test(url.pathname) ||
      !response.ok
    ) {
      return response;
    }

    refreshQueued = true;

    if (refreshInProgress) return response;

    refreshInProgress = true;

    try {
      while (refreshQueued) {
        refreshQueued = false;

        // Fetch the authoritative current cart.
        const cartResponse = await originalFetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!cartResponse.ok) {
          throw new Error('Could not fetch the updated cart.');
        }

        const cart = await cartResponse.json();

        // Request fresh server-rendered Horizon drawer HTML.
        const sectionUrl = new URL(
          window.location.pathname,
          window.location.origin
        );

        sectionUrl.searchParams.set(
          'sections',
          'cart-drawer-section'
        );

        const sectionResponse = await originalFetch(sectionUrl, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });

        if (!sectionResponse.ok) {
          throw new Error('Could not fetch the cart drawer section.');
        }

        const sections = await sectionResponse.json();
        const drawerHtml = sections['cart-drawer-section'];

        if (!drawerHtml) {
          throw new Error(
            'Shopify did not return the cart-drawer-section HTML.'
          );
        }

        // Create the event Horizon listens for.
        let resolveUpdate;

        const updatePromise = new Promise((resolve) => {
          resolveUpdate = resolve;
        });

        const event = new CustomEvent(
          'shopify:cart:lines-update',
          {
            bubbles: true,
            detail: {},
          }
        );

        Object.defineProperties(event, {
          action: { value: 'add' },
          context: { value: 'product' },
          lines: { value: [] },
          promise: { value: updatePromise },
        });

        // Notify Horizon's cart components.
        document.dispatchEvent(event);

        // Supply the quantity for the cart icon and the HTML for
        // the drawer refresh.
        resolveUpdate({
          cart: {
            totalQuantity: cart.item_count,
          },
          detail: {
            itemCount: cart.item_count,
            sections: {
              'cart-drawer-section': drawerHtml,
            },
            didError: false,
          },
        });

        // Explicitly update the visible cart bubble as well.
        const cartIcon = document.querySelector('cart-icon');

        if (
          cartIcon &&
          typeof cartIcon.renderCartBubble === 'function'
        ) {
          cartIcon.renderCartBubble(cart.item_count);

          console.log(
            '[swishlist-cart-bridge] Cart bubble updated:',
            cart.item_count
          );
        } else {
          console.warn(
            '[swishlist-cart-bridge] cart-icon component not found.'
          );
        }

        console.log(
          '[swishlist-cart-bridge] Cart and drawer refresh requested:',
          cart.item_count
        );

        // Allow any additional cart additions to trigger another refresh.
        await Promise.resolve();
      }
    } catch (error) {
      console.error(
        '[swishlist-cart-bridge] Refresh failed:',
        error
      );
    } finally {
      refreshInProgress = false;
    }

    return response;
  };
})();